import router from "@/router";
import store from "@/store";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { getSEOConfig, setPageSEO } from "@/utils/seoConfig";
import { Message } from "element-ui";
import { buildAuthUrl } from "@/utils/common";

// 配置NProgress进度条
NProgress.configure({ showSpinner: false });

/**
 * 路由守卫
 * - 处理用户登录状态验证
 * - 实现内部调配页面访问控制
 * - 加载必要的页面资源
 */
router.beforeEach(async (to, from, next) => {
  // 启动进度条
  NProgress.start();

  // 1. 获取路由信息
  const isNbRoute = to.params.code === "nb" || to.name == "nbtp";

  // 2. 检查并更新用户信息（内部逻辑已封装到Vuex action中）
  await store.dispatch("permission/checkAndUpdateUserInfo", { isNbRoute });

  // 3. 获取最新的用户状态
  const latestUserInfo = store.getters.userInfo;
  const isLogin = store.getters.isLogin;

  // 4. 内部调配页面访问控制
  if (isNbRoute) {
    // 未登录用户访问内部调配页面，重定向到首页
    if (!isLogin) {
      Message({
        message: "请登录后查看",
        duration: 2 * 1000,
      });
      NProgress.done();
      return next({ path: "/" });
    }

    // 已登录但不是内部调配用户访问内部调配页面，重定向到首页
    if (!latestUserInfo.isNb) {
      Message({
        message: "您非中化集团内部单位，无权限进入！",
        duration: 2 * 1000,
      });
      NProgress.done();
      return next({ path: "/" });
    }
  }

  // 5. 加载页面必要资源（内部逻辑已封装到Vuex action中）
  await store.dispatch("permission/loadPageResources", to);

  // 6. 页面初始化操作
  // 清空详情页标题，避免面包屑显示异常
  store.commit("permission/SET_DETAIL_TITLE", "");

  // 设置页面SEO信息
  const seoConfig = getSEOConfig(to.path);
  setPageSEO(seoConfig, true);

  // 7. 允许路由跳转
  next();
});

/**
 * 路由跳转完成后的钩子
 * - 完成进度条显示
 */
router.afterEach(() => {
  NProgress.done();
});
